<template>
  <div class="cmp-accounting-invoices-payment-termns selectedInvoice-info dbox">
    <TextField2
      :disabled="selectedInvoice.disabled"
      :id="'due_days'"
      :label="$t('due_days')"
      :value="selectedInvoice.invoice.due_days"
      :placeholder="$t('due_days')"
      @change="onTextFieldValueChange"
    />
    <Checkbox2
      :disabled="selectedInvoice.disabled"
      :id="'end_of_month_flag'"
      :label="$t('end_of_month')"
      :value="selectedInvoice.invoice.end_of_month_flag"
      :placeholder="$t('end_of_month')"
      @input="onCheckboxChange"
    />
    <DatePicker2
      :label="$t('date')"
      :disabled="selectedInvoice.disabled"
      id="due_date"
      :placeholder="$t('due_date')"
      :value="dueDate"
      @input="onDueDateUpdate"
    />
    <div class="ut-flex" style="border-bottom: 1px solid var(--sprt-5)">
      <TextField2
        :label="$t('discount_percent')"
        :disabled="selectedInvoice.disabled"
        :id="'discount_percent'"
        :ta="'left'"
        :cw="`clamp(30px, ${
          (
            (selectedInvoice &&
              selectedInvoice.invoice &&
              selectedInvoice.invoice.discount_percent) ||
            'discountpe'
          ).toString().length * 13
        }px, 250px)`"
        :type="'percent'"
        :value="selectedInvoice.invoice.discount_percent"
      
        :placeholder="$t('discount_percent')"
        :bb="'none'"
        @change="onTextFieldValueChange"
      />
    </div>
    <!-- :cw="`clamp(30px, ${
          (
            (selectedInvoice &&
              selectedInvoice.invoice &&
              selectedInvoice.invoice.discount_percent) ||
            ''
          ).toString().length * 13
        }px, 250px)`" -->
    <TextField2
      :label="$t('discount_days')"
      :disabled="selectedInvoice.disabled"
      :id="'discount_days'"
      :value="selectedInvoice.invoice.discount_days"
      :placeholder="$t('discount_days')"
      @change="onTextFieldValueChange"
    />
    <Dropdown2
      :label="$t('payment_method')"
      :disabled="selectedInvoice.disabled"
      :options="selectedInvoice.payment_methodsTV"
      :selected="
        selectedInvoice.payment_methodsTV.find(
          (c) => c.value == selectedInvoice.invoice.payment_method_id
        )
      "
      :placeholder="$t('payment_method')"
      v-on:selectedChange="(e) => onDropdownChange('payment_method_id', e)"
    />
    <Dropdown2
      :label="$t('money_account')"
      :disabled="selectedInvoice.disabled"
      :options="selectedInvoice.money_accountsTV"
      :selected="
        selectedInvoice.money_accountsTV.find(
          (c) => c.value == selectedInvoice.invoice.money_account_id
        )
      "
      :placeholder="$t('money_account')"
      v-on:selectedChange="(e) => onDropdownChange('money_account_id', e)"
      bb="0px"
    />
    <!--
    <div class="form-group" v-if="selectedInvoice">
      <v-layout row wrap>
        <v-flex xs4>
          <TextField
            :disabled="selectedInvoice.disabled"
            :id="'due_days'"
            v-bind="textFieldConfig"
            :value="selectedInvoice.invoice.due_days"
            :placeholder="$t('due_days')"
            @valuechanged="onTextFieldValueChange"
          />
        </v-flex>
        <v-flex xs4>
          <v-layout row wrap pa-2 mt-2>
            <v-flex xs2>
              <div class="dt-checkbox v2 s1"
                :class="{
                  'disabled': selectedInvoice.disabled
                }"
              >
                <input type="checkbox" 
                  @click="e => onCheckboxChange('end_of_month_flag', e)" 
                  :name="'end_of_month_flag'"
                  :id="'end_of_month_flag'"
                  :disabled="selectedInvoice.disabled"
                  :checked="selectedInvoice.invoice.end_of_month_flag == '1'" >
                <div class="checkmark"></div>
            </div>
            </v-flex>
            <v-flex xs10>
              End of Month
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs4>
          <DatePicker
            :disabled="selectedInvoice.disabled"
            id="due_date"
            :placeholder="$t('due_date')"
            :value="dueDate"
            @valuechanged="onDueDateUpdate"
          />
        </v-flex>

      </v-layout>
      <v-layout row wrap>
        <v-flex xs4>
          <TextField
            :disabled="selectedInvoice.disabled"
            :id="'discount_percent'"
            v-bind="textFieldConfig"
            :value="selectedInvoice.invoice.discount_percent"
            :placeholder="$t('discount_percent')"
            @valuechanged="onTextFieldValueChange"
          />
        </v-flex>
        <v-flex xs4>
          <TextField
            :disabled="selectedInvoice.disabled"
            :id="'discount_days'"
            v-bind="textFieldConfig"
            :value="selectedInvoice.invoice.discount_days"
            :placeholder="$t('discount_days')"
            @valuechanged="onTextFieldValueChange"
          />
        </v-flex>
      </v-layout>
      <Dropdown
        :disabled="selectedInvoice.disabled"
        class="dt-dropdown"
        :options="selectedInvoice.payment_methodsTV"
        :selected="selectedInvoice.payment_methodsTV.find(c => c.value == selectedInvoice.invoice.payment_method_id)"
        box
        :placeholder="$t('payment_method')"
        v-on:selectedChange="e => onDropdownChange('payment_method_id', e)"
        :listHeight="150"
      ></Dropdown>
      <Dropdown
        :disabled="selectedInvoice.disabled"
        class="dt-dropdown"
        :options="selectedInvoice.money_accountsTV"
        :selected="selectedInvoice.money_accountsTV.find(c => c.value == selectedInvoice.invoice.money_account_id)"
        box
        :placeholder="$t('money_account')"
        v-on:selectedChange="e => onDropdownChange('money_account_id', e)"
        :listHeight="150"
      ></Dropdown>
    </div>
    -->
  </div>
</template>

<script>
import * as D from "date-fns";

import { EventHooks } from "../../../../plugins/text-field";
import { createCountriesTV } from "../../../../models/country.model";
import { createLanguageTV } from "../../../../models/language.model";
import { tv } from "../../../../models/text-value.model";
import { createUserTV } from "../../../../models/user.model";
import DatePicker from "@plugins/text-field/date-picker";
import { createCurrencyTV } from "../../../../models/currency.model";
import { addDays, differenceInDays } from "date-fns";
import { Number } from "sanctuary-def";

export default {
  components: {
    DatePicker,
  },
  props: {
    selectedInvoice: {
      required: true,
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
    };
  },
  computed: {
    due_days: function () {
      return this.selectedInvoice.invoice.due_days || 0;
    },
    invoiceDate: function () {
      return this.selectedInvoice.invoice.invoice_date;
    },
    dueDate: function () {
      return addDays(this.invoiceDate, this.due_days);
    },
  },
  methods: {
    onTextFieldValueChange: function ({ name, value }) {
      if (name == "discount_percent" && value % 1 == 0) {
        value = (+value).toFixed(2);
      }
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      this.$emit("changed", { name, value: value.value });
    },
    onCheckboxChange: function ({ name, value }) {
      this.$emit("changed", {
        name,
        value: value ? "1" : "0",
      });
    },
    onDueDateUpdate: function ({ name, value }) {
      // console.log(name, value);
      if (value == "") {
        return;
      }
      const dueDays = differenceInDays(value, this.invoiceDate);
      // console.log("Log: dueDays", dueDays)
      this.$emit("changed", {
        name: "due_days",
        value: dueDays,
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-accounting-invoices-payment-termns {
  .form-group .dt-dropdown {
    margin: 4px 5px !important;
  }

  /* .dt-checkbox {
    .checkmark,
    input {
      margin-top: 5px;
    }
  } */
}
</style>
